import React from 'react';
import styled from 'styled-components';

import {
  Div, colors, weight, Figure,
} from 'globalStyle';
import { TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import { Dialog, DialogContent } from '@material-ui/core';
import arrowLeft from 'assets/icons/arrowLeftHeader.svg';
import closeIcon from 'assets/icons/closeIcon.svg';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { formatNumber } from 'util/formatNumber';
import { routes } from 'routes';

export const SuccessfulInvestmentModal = ({
  companyName,
  onClick,
  projectName,
  currentAmount,
  maxAmount,
  currencyIso,
  amountInvested,
}) => (
  <Dialog
    open
    PaperProps={{
      style: { borderRadius: '20px', padding: '20px' },
    }}
    maxWidth="md"
  >
    <Div isFlex justify="space-between">
      <Figure
        style={{
          width: '22px',
          height: '25px',
          cursor: 'pointer',
        }}
        onClick={() => {
          onClick();
        }}
      >
        <img
          src={arrowLeft}
          alt="atrás"
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Figure>
      <TextLight weight={weight.BOLD} mb={5} size={14} width="auto">
        Inversión
      </TextLight>
      <Figure
        style={{
          width: '15px',
          height: '18px',
          cursor: 'pointer',
        }}
        onClick={() => {
          onClick();
        }}
      >
        <img
          src={closeIcon}
          alt="cerrar"
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Figure>
    </Div>
    <DialogContent
      style={{
        'max-width': '600px',
        padding: '20px',
        width: '100%',
        overflowX: 'hidden',
      }}
      align="center"
    >
      <TextLight weight={weight.BOLD} size={14} isUpper>
        {projectName}
      </TextLight>
      <TextLight size={12} mb={20}>
        {`Por ${capitalizeFirstLetterString(companyName)}`}
      </TextLight>

      <TextLight
        color={colors.primary}
        weight={weight.BOLD}
        width="auto"
        size={14}
      >
        Total recaudado
      </TextLight>
      <TextLight weight={weight.BOLD} width="auto" size={20}>
        {formatNumber(currentAmount, null, currencyIso)}
      </TextLight>
      <Line margin="15px 0" width="250px" />
      <TextLight
        color={colors.primary}
        weight={weight.BOLD}
        width="auto"
        size={14}
      >
        Meta del proyecto
      </TextLight>
      <TextLight weight={weight.BOLD} width="auto" size={20}>
        {formatNumber(maxAmount, null, currencyIso)}
      </TextLight>
      <Line margin="20px 0" width="100%" />
      <TextLight size={18}>
        La inversión de
        <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
          {formatNumber(amountInvested, null, currencyIso)}
        </span>
        en el proyecto
        <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
          {capitalizeFirstLetterString(projectName)}
        </span>
        se ha realizado con éxito.
      </TextLight>

      <Div
        isFlex
        mt={50}
        width="100%"
        style={{ flexWrap: 'wrap', gap: '20px' }}
      >
        <Hollow
          onColorType="primary"
          href={routes.profile.invert}
          padding="12px 0"
          size="14px"
          style={{ borderRadius: '30px', width: '220px', height: '45px' }}
        >
          Mis inversiones
        </Hollow>
        <Hollow
          onColorType="white"
          color={colors.primary}
          href={routes.home}
          padding="12px 0"
          size="14px"
          style={{ borderRadius: '30px', width: '220px', height: '45px' }}
        >
          Inicio
        </Hollow>
      </Div>
    </DialogContent>
  </Dialog>
);

const Line = styled.div`
  width: ${({ width }) => width && width};
  margin: ${({ margin }) => margin && margin};
  height: 1px;
  border-bottom: 1px solid ${colors.GRAY_4};
`;
